var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoResultsSecondary = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 101,
  height: 100,
  fill: "none",
  viewBox: "0 0 101 100",
  ref: ref
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 51.1,
  cy: 50,
  fill: "var(--illustrations-background)",
  rx: 49.41,
  ry: 50
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1186FA",
  d: "M88.66 19.14a2.9 2.9 0 0 0-2.59-3.23l-50.23-4.98a2.9 2.9 0 0 0-3.16 2.52l-8.45 65.9a2.9 2.9 0 0 0 2.6 3.27l47.11 4.5a2.9 2.9 0 0 0 3.15-2.56l4.89-43.28 1.24.12a2.9 2.9 0 0 0 3.16-2.56z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#205CDF",
  d: "m78.32 17.02-45.38-3.57-.67 3.27 19.79 7.43L75.1 69.93l5.67-49.9a2.7 2.7 0 0 0-2.46-3Z",
  style: {
    mixBlendMode: "overlay"
  }
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DEE7FA",
  d: "M26.98 17.66a2.48 2.48 0 0 1 2.65-2.32l46.47 3.28c1.36.1 2.4 1.29 2.3 2.66l-4.1 60.54a2.48 2.48 0 0 1-2.66 2.31l-46.47-3.28a2.49 2.49 0 0 1-2.3-2.66z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m71.49 26.27 3.56 43.4-8.21-31.5-10.28-20.88 3.25.16z",
  style: {
    mixBlendMode: "overlay"
  }
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.05 23.22a2.6 2.6 0 0 1 2.22-2.9l37.04-5.1 14.52 11.83 6.1 49.4a2.6 2.6 0 0 1-2.23 2.9l-47.13 6.18a2.59 2.59 0 0 1-2.9-2.25z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#205CDF",
  d: "M32.3 61.84c-1.07-1-2.01-2.12-2.8-3.35l-.09-.15-2.3 2.06 2.87 3.5 2.31-2.06Z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m28.98 61.57-1.74-1.23 2.88 3.47c.43-.38-.1-1.7-.62-1.94a3.5 3.5 0 0 1-.52-.3",
  style: {
    mixBlendMode: "overlay"
  }
}), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#1186FA",
  d: "M27.06 60.16a.72.72 0 0 0-.99-.12L3.56 76.75c-2.3 1.7-2.65 5-.78 7.16a4.86 4.86 0 0 0 7 .37l20.54-19.17c.29-.27.31-.7.06-1z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#1186FA",
  fillOpacity: 0.1,
  d: "M29.86 48.49a14.93 14.93 0 0 0 14.25 15.58 14.92 14.92 0 0 0 15.51-14.32 14.93 14.93 0 0 0-14.25-15.58 14.92 14.92 0 0 0-15.5 14.32Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#1186FA",
  fillOpacity: 0.32,
  fillRule: "evenodd",
  d: "M43.98 67.14A18 18 0 0 1 26.8 48.36 17.98 17.98 0 0 1 45.5 31.1a18 18 0 0 1 17.17 18.78 17.98 17.98 0 0 1-18.7 17.26Zm.13-3.05a14.96 14.96 0 0 1-14.28-15.6 14.94 14.94 0 0 1 15.54-14.34 14.96 14.96 0 0 1 14.27 15.6A14.94 14.94 0 0 1 44.11 64.1Z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M54.28 40.8a12.56 12.56 0 0 0-17.96 17.4 12.56 12.56 0 0 1-4.36-9.54c0-6.94 5.61-12.57 12.54-12.57a12.5 12.5 0 0 1 9.78 4.7Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF2F5",
  d: "m57.1 25.73-1.79-10.36 14.57 11.68-8.86 1.47c-1.84.31-3.6-.94-3.91-2.79Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#1186FA",
  fillOpacity: 0.2,
  d: "M43.14 51.88a3.4 3.4 0 0 1 .01-1.18c.07-.37.18-.71.34-1.03.16-.34.35-.66.55-.95l.68-.9.47-.64a2.87 2.87 0 0 0 .6-2.25c-.1-.58-.34-1-.73-1.27a1.86 1.86 0 0 0-1.45-.3c-.77.12-1.34.39-1.72.8-.35.42-.56 1.08-.6 2l-3 .07q.03-1.005.3-1.92a4.6 4.6 0 0 1 2.33-2.9c.63-.35 1.4-.6 2.32-.73 1.62-.25 2.94-.06 3.97.55a3.75 3.75 0 0 1 1.84 2.84 4.7 4.7 0 0 1-.2 2.35c-.13.3-.28.58-.46.84s-.36.53-.56.79l-.66.9c-.2.28-.38.56-.52.85-.15.27-.25.55-.32.84a2.3 2.3 0 0 0-.03.9l.06.39-3.14.47zm.29 2.06 3.14-.47.55 3.64-3.15.48z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m74.33 81.14-25.11 1.4L75 69.93z",
  style: {
    mixBlendMode: "overlay"
  }
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoResultsSecondary);
export default ForwardRef;